import React, { useEffect, useState } from "react";
import { Box, styled, Paper } from "@mui/material";
import AccordionTable from "./AccordionTable";
import LoadingIcon from "../../reusable-component/LoadingIcon";
import PaginationFooter from "../../reusable-component/PaginationFooter";
import NoData from "../../reusable-component/NoData";
import { WorkflowApi } from "../../services/WorkflowApi";
import { Button, Modal, Input } from "antd";
import AddWorkflow from "./AddWorkflow";
import { useAxios } from "../../contexts/AxiosProvider";
import { useSnackbar } from "notistack";
import FilterWorkflow from "./FilterWorkflow";
import { FilterOutlined } from "@ant-design/icons";
import { getEnvironmentConfig } from "../../constants/CloudConstant";

const { Search } = Input;

const WorkflowContainer = styled(Box)(({ openDrawer, isDashboard }) => ({
  marginLeft: openDrawer ? 240 : isDashboard ? 0 : 80,
  width: openDrawer
    ? "calc(100% - 255px)"
    : isDashboard
    ? "calc(100% - 5px)"
    : "calc(100% - 85px)",
  // backgroundColor: "#f8f8ff",
  // border: openDrawer ? "2px solid green" : "2px solid blue",
  height: "calc(100vh - 70px)",
}));

const SearchAndFilter = styled(Box)(() => ({
  display: "flex",
  margin: "20px 20px",
  flexDirection: "row",
  justifyContent: "space-between",
}));

const Workflow = ({ openDrawer, WorkflowData, userData }) => {
  const ADD_WORKFLOW_INITIAL_STATE = {
    domain: {
      domain_name: "",
      domain_id: "",
    },
    client: {
      client_name: "",
      client_id: "",
    },
    engagement: {
      engagement_name: "",
      engagement_id: "",
    },
    processType: "",
    workflowName: "",
    userId: userData.userId,
    userName: userData.username,
    connectionType: "emr",
    connectionName: "emr",
    execution_mode: "Batch",
    cloudEnvironment: getEnvironmentConfig().cloudEnvironment,
  };

  const [filterState, setFilterState] = useState({
    client: false,
    client_name: "",
    client_id: "",
    engagement: false,
    engagement_name: "",
    engagement_id: "",
  });
  const axios = useAxios();
  const { enqueueSnackbar } = useSnackbar();
  const [workflows, setWorkflows] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const rowsPerPage = 10;
  const [addWorkflowData, setAddWorkflowData] = useState(
    ADD_WORKFLOW_INITIAL_STATE
  );
  const [isAddWorkflowModalOpen, setIsAddWorkflowModalOpen] = useState(false);
  const showAddWorkflowModal = () => {
    setIsAddWorkflowModalOpen(true);
  };
  const handleOk = () => {
    createWorkflow(addWorkflowData);
  };
  const handleCancel = () => {
    setAddWorkflowData(ADD_WORKFLOW_INITIAL_STATE);
    setIsAddWorkflowModalOpen(false);
  };

  function validateData(obj) {
    const errors = [];

    // Check if workflowName is empty
    if (!obj.workflowName) {
      errors.push("Workflow name is required.");
    }

    // Check if userId is empty
    else if (!obj.userId) {
      errors.push("User ID is required.");
    }

    // Check if connectionType is empty
    else if (!obj.connectionType) {
      errors.push("Connection type is required.");
    }

    // Check if connectionName is empty
    else if (!obj.connectionName) {
      errors.push("Connection name is required.");
    }

    // Check if execution_mode is empty
    else if (!obj.execution_mode) {
      errors.push("Execution mode is required.");
    }

    // Check if process_type is empty
    else if (!obj.process_type) {
      errors.push("Process type is required.");
    }

    // Check if cloudEnvironment is empty
    else if (!obj.cloudEnvironment) {
      errors.push("Cloud environment is required.");
    }

    // Check if engagement_id is empty
    else if (!obj.engagement_id) {
      errors.push("Pipeline ID is required.");
    }

    return errors;
  }

  const createWorkflow = async (addWorkflowData) => {
    const data = {
      workflowName: addWorkflowData.workflowName,
      userId: addWorkflowData.userId,
      userName: addWorkflowData.userName,
      connectionType: addWorkflowData.connectionType,
      connectionName: addWorkflowData.connectionName,
      execution_mode: addWorkflowData.execution_mode,
      process_type: addWorkflowData.processType,
      cloudEnvironment: addWorkflowData.cloudEnvironment,
      engagement_id: addWorkflowData.engagement.engagement_id,
    };
    const alphanumericWithLetter = /^(?=.*[a-zA-Z])[a-zA-Z0-9 ]+$/;
    if (!alphanumericWithLetter.test(addWorkflowData.workflowName)) {
      enqueueSnackbar("Workflow name should contain letters!!", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      return;
    }

    const validationErrors = validateData(data);
    if (validationErrors.length === 0) {
      try {
        const response = await WorkflowApi.createWorkflow(axios, data);
        if (response.status === 201) {
          enqueueSnackbar("Workflow added successfully!", {
            variant: "success",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
          fetchAllWorkflows();
          setAddWorkflowData(ADD_WORKFLOW_INITIAL_STATE);
          setIsAddWorkflowModalOpen(false);
        }
      } catch (error) {
        if (error.response?.status === 403) {
          enqueueSnackbar("You have only Read Permission !!", {
            variant: "error",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        } else if (error.response?.status === 400) {
          enqueueSnackbar(error, {
            variant: "error",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        } else if (error.response?.status === 409) {
          enqueueSnackbar("Pipeline with the same name already exists!", {
            variant: "error",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        } else if (error.response.status === 500) {
          enqueueSnackbar("Internal Server Error!!", {
            variant: "error",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        }
      }
    } else {
      validationErrors.forEach((error) => {
        enqueueSnackbar(error, {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      });
    }
  };

  const fetchAllWorkflows = async () => {
    setLoading(true);
    try {
      const data = {
        user_id: userData.userId,
        client: false,
        client_id: "",
        engagement: !WorkflowData.engagement_id.includes("all-workflows"),
        engagement_id: WorkflowData.engagement_id,
        process_type: WorkflowData.processType,
        search: false,
        searchParam: "",
        status: WorkflowData.dashboard ? "default" : "approved",
      };

      const response = await WorkflowApi.getAllWorkflows(axios, data);
      if (response.status === 200) {
        setWorkflows(response.data);
      } else if (response.status === 404) {
        setWorkflows([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllWorkflows();
  }, [WorkflowData.processType]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const WorkflowNoData = {
    title: "No data to display!",
    text: "You don’t have any workflows to review. Start adding workflow to see the data.",
    addBtnText: "Add New Workflow",
  };

  const onSearch = async (value, _e, info) => {
    setLoading(true);
    try {
      const data = {
        user_id: userData.userId,
        process_type: WorkflowData.processType,
        client: false,
        client_id: "",
        engagement: !WorkflowData.engagement_id.includes("all-workflows"),
        engagement_id: WorkflowData.engagement_id,
        search: true,
        searchParam: value,
        status: WorkflowData.dashboard ? "default" : "approved",
      };

      const response = await WorkflowApi.getAllWorkflows(axios, data);
      if (response.status === 200) {
        setWorkflows(response.data);
      } else if (response.status === 404) {
        setWorkflows([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const onFilterWorkflow = async () => {
    setLoading(true);
    try {
      const data = {
        user_id: userData.userId,
        process_type: WorkflowData.processType,
        client: filterState.client,
        client_id: filterState.client_id,
        engagement: filterState.engagement,
        engagement_id: filterState.engagement_id,
        search: false,
        searchParam: "",
        status: WorkflowData.dashboard ? "default" : "approved",
      };

      const response = await WorkflowApi.getAllWorkflows(axios, data);
      if (response.status === 200) {
        setWorkflows(response.data);
      } else if (response.status === 404) {
        setWorkflows([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <WorkflowContainer
        openDrawer={openDrawer}
        isDashboard={WorkflowData.dashboard}
      >
        {WorkflowData.isSearchFilterVisible && (
          <SearchAndFilter>
            <Search
              placeholder="Search Workflow"
              allowClear
              enterButton
              size="large"
              onSearch={onSearch}
              style={{ width: "20%" }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FilterWorkflow
                user_id={userData.userId}
                filterState={filterState}
                setFilterState={setFilterState}
              />
              <Button
                type="dashed"
                shape="circle"
                icon={<FilterOutlined />}
                style={{ marginRight: 15 }}
                onClick={onFilterWorkflow}
                disabled={filterState.client_id === ""}
              />
              <Button
                type="primary"
                size="large"
                onClick={showAddWorkflowModal}
              >
                Add Workflow
              </Button>
            </div>
          </SearchAndFilter>
        )}

        <div
          style={{
            width: "96%",
            margin: "20px 20px",
            fontWeight: 640,
            height: "calc(100vh - 170px)",
            overflow: "auto",
          }}
        >
          {!loading && workflows.length === 0 ? (
            <Paper elevation={3} sx={{ height: "330px", marginTop: "10px" }}>
              <NoData
                title={WorkflowNoData.title}
                text={WorkflowNoData.text}
                addBtnText={WorkflowNoData.addBtnText}
              />
            </Paper>
          ) : (
            <>
              <AccordionTable
                data={workflows}
                rowsPerPage={rowsPerPage}
                page={page}
                workflowData={WorkflowData}
                userData={userData}
                fetchAllWorkflows={fetchAllWorkflows}
              />
              <PaginationFooter
                tableData={workflows}
                page={page}
                rowsPerPage={rowsPerPage}
                handleChangePage={handleChangePage}
              />
            </>
          )}
          {loading && <LoadingIcon />}
        </div>
        <Modal
          title="Add New Workflow"
          open={isAddWorkflowModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <AddWorkflow
            user_id={userData.userId}
            username={userData.username}
            open={isAddWorkflowModalOpen}
            addWorkflowData={addWorkflowData}
            setAddWorkflowData={setAddWorkflowData}
          />
        </Modal>
      </WorkflowContainer>
    </>
  );
};
export default Workflow;
